import { Box, BoxProps } from "@mui/material";
import { mergeSx } from "src/utils/styles.ts";
import { actionBarSxContentOnly } from "./actionBarStyles";

export interface AavoActionBarProps extends BoxProps {
	type?: "dataGrid" | "default";
}

export const AavoActionBar = ({ sx, type = "default", children, ...other }: AavoActionBarProps) => {
	return (
		<Box
			sx={mergeSx(
				{
					display: "flex",
					alignSelf: "flex-start",
					alignItems: "stretch",
					flexWrap: "wrap",
					rowGap: 0.5,
					columnGap: 0.75,
					...actionBarSxContentOnly,
				},
				type === "default" && {
					padding: 1,
				},
				type === "dataGrid" && {
					paddingX: 0.5,
					paddingTop: 1,
					paddingBottom: 0.25,
				},
				sx,
			)}
			{...other}
		>
			{children}
		</Box>
	);
};
